import { Routes } from '@angular/router';
import { FallbackRedirectComponent } from '@app/layouts/fallback-redirect';
import { HospitalLayoutComponent } from '@app/layouts/hospital/hospital-layout';
import { hospitalChildRoutes } from '@app/layouts/hospital/hospital.routes';
import { AdminLayoutComponent } from '@app/layouts/admin/admin-layout';
import { adminChildRoutes } from '@app/layouts/admin/admin.routes';
import { AuthGuardService } from '@app/core/guards/auth/auth-guard';
import { FacadeResolver } from '@app/shared/resolvers/facade-resolver';

export const routes: Routes = [
  {
    path: 'hospital',
    component: HospitalLayoutComponent,
    canActivate: [AuthGuardService],
    resolve: {
      facadeResolver: FacadeResolver,
    },
    children: hospitalChildRoutes,
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuardService],
    children: adminChildRoutes,
  },
  {
    path: '**',
    canMatch: [AuthGuardService],
    component: FallbackRedirectComponent,
  },
];
